import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'metodh-auth',
  templateUrl: './metodh-auth.component.html',
  styleUrls: ['./metodh-auth.component.scss'],
})
export class MetodhAuthComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
